/**
 * Google Analytics 4 (GA4) Utility Functions
 * Enables event logging, virtual page view tracking, and user profile properties.
 */

const GA_MEASUREMENT_ID = 'G-25YHW7137X';

const isLocalhost = typeof window !== 'undefined' && (
  window.location.hostname === 'localhost' ||
  window.location.hostname.endsWith('.localhost') ||
  window.location.hostname === '127.0.0.1'
);

/**
 * Tracks a virtual page view (crucial for Single Page Applications like React Router)
 * @param {string} pagePath - The URL path (e.g. '/interview/123')
 * @param {string} pageTitle - The title of the page
 */
export const trackPageView = (pagePath, pageTitle) => {
  if (isLocalhost) return;
  if (window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: pagePath,
      page_title: pageTitle || document.title,
    });
  }
};

/**
 * Tracks a custom event in Google Analytics 4
 * @param {string} eventName - Name of the custom event (using snake_case, e.g., 'ide_run_code')
 * @param {Object} params - Key-value parameters containing extra information for the event
 */
export const trackEvent = (eventName, params = {}) => {
  if (isLocalhost) return;
  if (window.gtag) {
    window.gtag('event', eventName, params);
  }
};

/**
 * Set persistent user attributes for the analytics session (e.g. role: 'HR', 'Candidate')
 * @param {Object} properties - User property key-value parameters
 */
export const setUserProperties = (properties = {}) => {
  if (isLocalhost) return;
  if (window.gtag) {
    window.gtag('set', 'user_properties', properties);
  }
};

/**
 * Associates a logged-in user's unique system ID with the GA session
 * @param {string|number} userId - Unique user ID in the system
 */
export const setUserId = (userId) => {
  if (isLocalhost) return;
  if (window.gtag && userId) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      user_id: userId,
    });
  }
};
